<div class="central-lobby-view">
  <div>
    <div class="cc-action-panel row">
      <div class="central-view-filters row">
        <div #randomdiv style="display: none"></div>
        <div class="col-md-6">
          <app-location-multi-selector  [isLobby]="true" labelText=" {{'_General_Location_Text_' | translate }}" selectedLocationName="{{'_General_No_Branches_Text_' | translate}}"
            [selectorDisabled]="selectorDisable" (onLocationsData)="handleDefaultSelection($event)"
            (onChange)="handleLocationData($event)" [checkedKeys]="checkedKeys" [dispatchStateEvent]="false"
            [hideBranchLess]="true" [isIncludeFloatLocation]="false"></app-location-multi-selector>
        </div>
        <div class="col-md-6">
          <div class="checkbox">
            <label>
              <input (change)="spanishPreffered($event)" id="spanishRequest" class="cc-filter-checkbox" type="checkbox"
                kendoCheckBox value="true" #isSpanish />
              {{'_Lobby_Show_Spanish_Requests_Only_Text_' | translate }}
            </label>
          </div>
        </div>
      </div>

      <div class="cc-search">
        <input class="form-control" placeholder="{{'_General_Search_Text_' | translate }}" (keydown.enter)="searchKeyWordChange()" id="searchInput" 
          [(ngModel)]="searchText" />
        <button *ngIf="searchText" [ngClass]="{ 'show-btn': searchText !== '' }" class="cc-close-btn"
          (click)="clearSearchFilter()">
          <span class="fas fa-times"></span>
        </button>
        <button *ngIf="searchText !== null" (click)="searchKeyWordChange()" class="cc-search-btn">
          <span class="fas fa-search"></span>
        </button>
      </div>
    </div>
  </div>

  <div class="grid-view central-views-grid-wrapper">
    <kendo-grid [skip]="skip" [data]="data" [pageSize]="pageSize" [pageable]="true"
      [sortable]="{ allowUnsort: false, mode: 'single' }" [sort]="sort" [scrollable]="'scrollable'"
      (pageChange)="onPageChange($event)" (sortChange)="sortChange($event)">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
      <kendo-grid-column field="type" [sortable]="false" title="{{'_General_Type_Text_' | translate }}" [width]="200"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex align-items-center">
            <div class="lobby-grid-icon-area">
              <button *ngIf="dataItem.appointmentId == null && dataItem.type == 'Lobby'" class="cc-icon-btn cursor"
                title="{{'_General_Report_WalkIn_Text_' | translate }}">
                <span class="fas fa-walking"></span>
              </button>
              <button *ngIf="dataItem.appointmentTypeId == 1 && dataItem.appointmentStatusId != 13" class="cc-icon-btn cursor" title="{{'_General_InPerson_Appointment_Text_' | translate }}">
                <img class="in-person-appointment-icon" src="assets/images/icon/in-person-appointment.svg" alt=""/>
              </button>
              <button *ngIf="dataItem.appointmentTypeId == 1 && dataItem.appointmentStatusId == 13" class="cc-icon-btn cursor" title="{{'_General_InPerson_Appointment_Text_' | translate }} : {{'_RemoteCheckIn_' | translate}}">
                <img class="in-person-appointment-icon" src="assets/images/icon/in-person-appointment.svg" alt=""/>
              </button>
              <button *ngIf="dataItem.appointmentTypeId == 2 && dataItem.appointmentStatusId != 13" class="cc-icon-btn cursor" title="{{'_General_Phone_Appointment_Text_' | translate }}">
                <span class="fas fa-phone"></span>
              </button>
              <button *ngIf="dataItem.appointmentTypeId == 2 && dataItem.appointmentStatusId == 13" class="cc-icon-btn cursor" title="{{'_General_Phone_Appointment_Text_' | translate }} : {{'_RemoteCheckIn_' | translate}}">
                <span class="fas fa-phone"></span>
              </button>
              <button *ngIf="dataItem.appointmentTypeId == 5 && dataItem.appointmentStatusId != 13" class="cc-icon-btn cursor" title="{{'_General_Virtual_Appointment_Text_' | translate }}">
                <img class="virtual-appointment-icon" src="assets/images/icon/virtual-appointment.svg" alt=""/>
              </button>
              <button *ngIf="dataItem.appointmentTypeId == 5 && dataItem.appointmentStatusId == 13" class="cc-icon-btn cursor" title="{{'_General_Virtual_Appointment_Text_' | translate }} : {{'_RemoteCheckIn_' | translate}}">
                <img class="virtual-appointment-icon" src="assets/images/icon/virtual-appointment.svg" alt=""/>
              </button>
              <button *ngIf="dataItem.appointmentId == null && dataItem.type == 'Kiosk'" class="cc-icon-btn cursor"
                title="{{'_General_Report_WalkIn_Text_' | translate }}">
                <span class="fas fa-walking"></span>
              </button>
              <button *ngIf="dataItem.preferredLanguage == 3" class="cc-icon-btn cursor"
                title="{{'_General_Notes_ES_Speaker_Text_' | translate }}">
                <img class="spanish-speaker-icon" src="assets/images/icon/spanish-speaker-preferred.svg" alt=""/>
              </button>
            </div>
            <span class="ps-1">{{ (dataItem.appointmentId == null? dataItem.addedLocalTime : dataItem.appointmentLocalTime) | date: "h:mm a" }} ({{ dataItem.timeZone }})</span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="locationName" title="{{'_General_Location_Text_' | translate }}" [width]="200" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column *ngIf="showAccountNumber" field="accountNumber" title="{{'_Account_Number_Field_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="firstName" title="{{'_General_User_First_Name_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="lastName" title="{{'_General_User_Last_Name_Text_' | translate }}" [sortable]="true" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="personRequested" title="{{'_General_Report_Staff_Requested_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="serviceRequested" title="{{'_General_Request(s)_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button *ngIf="dataItem.serviceRequested.length > 1" class="cc-icon-btn"
            (click)="productClickedHandler(dataItem)">
            <span class="fas fa-plus"></span>
          </button>
          {{
          dataItem.serviceRequested.length > 1
          ? dataItem.serviceRequested[0]
          : dataItem.serviceRequested
          }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="waitTime" title="{{'_General_Report_Wait_Time_Text_' | translate }}" [width]="125" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-app-timer *ngIf="dataItem.appointmentStatusId != 13 ? true : false" [autoStart]="true" [startTime]="dataItem.waitTime" format="hms"></app-app-timer>
          {{dataItem.Type}}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="cell-items-center">
             <button *ngIf="dataItem.appointmentStatusId == 13" class="cc-icon-btn" 
            (click)="updateRemoteCheckedInVisitorStatus(dataItem, true)" title="{{'_Lobby_Grid_Mark_Arrived_Text_' | translate}}">
            <span class="fas fa-check"></span>
          </button>
          <button *ngIf="dataItem.appointmentStatusId == 13" class="cc-icon-btn" 
            (click)="updateRemoteCheckedInVisitorStatus(dataItem, false)"title="{{'_Lobby_Grid_Mark_Absent_Text_' | translate}}">
            <span class="fas fa-times"></span>
          </button>
            <button *ngIf="!(dataItem.appointmentStatusId == 13)" [disabled]="isAssisting"   [style.opacity]="isAssisting ? 0.5 : 1"
              [title]="isAssisting ? currentlyAssistingText : assistText"
              class="cc-icon-btn set-pointer-events" (click)="openAssist(dataItem)">
              <span class="fas fa-street-view"></span>
            </button>
          
           
            <span *ngIf="!(dataItem.appointmentStatusId == 13) && enableUserImpersonation && enableUserImpersonationForTenant" 
            title="{{'_Lobby_CheckIn_Impersonate_Assist_Text_' | translate}}" class="m-t-2"  (click)="openImpersonateAssist(dataItem)" >            
            <img class="imp-assist-icon" src="assets/images/icon/impersonate-assist.svg" alt="">            
          </span>
            <button  [ngClass]="{
              'disabledcls': dataItem.hasServiceProvided
           }" [disabled]="dataItem.hasServiceProvided" *ngIf="!(dataItem.appointmentStatusId == 13)" (click)="openPopUp(lwaPopUp, dataItem)" class="cc-icon-btn" title="{{'_General_LWA_Text_' | translate }}">
              <span class="fas fa-share-square"></span>
            </button>
            <button *ngIf="!(dataItem.appointmentStatusId == 13) && userPermissionList?.includes(46)" class="cc-icon-btn edit"
              (click)="openLobbyEdit(lobbyEdit, dataItem)" title="{{'_General_Button_Edit_Text_' | translate }}" kendoGridEditCommand>
              <span class="fas fa-pen"></span>
            </button>
            <button class="cc-icon-btn" (click)="openTextOnDemandPopup(dataItem)"
              *ngIf="!(dataItem.appointmentStatusId == 13) && dataItem.recieveTextMessage == true && userPermissionList?.includes(59)" title="{{'_General_Text_On_Demand_Text_' | translate }}">
              <span class="fas fa-comment-dots"></span>
            </button>
          <!-- <button class="cc-icon-btn" title="Text on Demand Messages"><span class="fas fa-comment-dots"></span></button> -->
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>

<kendo-dialog id="OnDemandText-popup" title="{{'General_Text_On_Demand_Message_Text_' | translate }}" *ngIf="OnDemandPopup"
  (close)="closeOnDemandTextPopop()" [minWidth]="250" [width]="650">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="psPanel">
    <div>
      {{'_General_Send_Message_Text_' | translate }}
    </div>
  </div>
  <div class="row pt-3">
    <div class="col-md-12">
      <label for="notes"> {{'_General_Message_Content_Header_Text_' | translate }}<span class="required-field">*</span></label>
      <div class="cc-textarea-container">
        <div class="cc-textarea">
          <textarea [(ngModel)]="message" (ngModelChange)="GetRemaningTextCount(message!.length)" maxlength="350"
            id="message" class="form-control" rows="3"></textarea>
          <div class="d-flex justify-content-between align-items-center pt-1">
            <label class="cc-validation" *ngIf="isMsgContentRequired">{{'_General_Message_Required_Text_' | translate }}</label>
            <span class="ms-auto">{{ remainingText }} {{'_General_Message_Characters_Remaining_Text_' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button class="btn btn-secondary" (click)="closeOnDemandTextPopop()">
      {{'_General_Button_Cancel_Text_' | translate }}
    </button>
    <button class="btn btn-primary" (click)="SendTextOnDemandMessage(message)" [disabled]="message == null">
      {{'_General_Send_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog id="assist-popup" title="{{'_General_Different_Person_Requested_Text_' | translate }}" *ngIf="assistPopup" (close)="submitNo()"
  [minWidth]="250" [width]="600">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="psPanel">
    <div>
      {{'_General_Person_Requested_Message_Text_' | translate : { value0: assistingLobbyRecord.personRequested} }}
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton class="btn btn-secondary" kendoButton (click)="submitNo()" primary="true">
      {{'_General_Action_Label_No_Text_' | translate }}
    </button>
    <button kendoButton class="btn btn-primary" kendoButton (click)="submitYes()" primary="true">
      {{'_General_Action_Label_Yes_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog id="assist-notification-popup" title="{{'_General_Different_Group_Requested_Text_' | translate }}" *ngIf="assistNotificationPopup" (close)="submitNo()"
  [minWidth]="250" [width]="600">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="psPanel">
    <p>
      {{'_General_Group_Requested_Message_Text_' | translate : { value0: assistingLobbyRecord.personRequested} }}
     
    </p>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton class="btn btn-secondary" kendoButton (click)="submitNo()" primary="true">
      {{'_General_Action_Label_No_Text_' | translate }}
    </button>
    <button kendoButton class="btn btn-primary" kendoButton (click)="submitYes()" primary="true">
      {{'_General_Action_Label_Yes_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-left-without-assistance #lwaPopUp></app-left-without-assistance>
<app-lobby-edit #lobbyEdit></app-lobby-edit>

<kendo-dialog id="serviceDialogModel" class="requests-list-popup" *ngIf="productAndServiceView"
  (close)="closeProductServiceDialog()" [minWidth]="250" [width]="600">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <kendo-dialog-titlebar>
    <div class="d-flex">
      <span class="request-list-name">
        {{
        productAndServiceData.firstName + " " + productAndServiceData.lastName
        }}
      </span>
      <span> {{'_General_Request(s)_Text_' | translate }} </span>
    </div>
  </kendo-dialog-titlebar>
  <div class="psPanel">
    <div class="ps-list">
      <ul>
        <li *ngFor="
            let field of productAndServiceData.requestedServices;
            let index = index
          ">
          {{ field.name }}
        </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton class="btn btn-primary" kendoButton (click)="closeProductServiceDialog()" primary="true">
      {{'_General_Button_Close_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-impersonate-assist  
  header="{{'_Lobby_CheckIn_Impersonate_Assist_Text_' | translate}}"
  [(locationId)]="currentLocationId"
  message=" {{'_Lobby_Central_Assist_Eligible_User_Text_' | translate}} {{currentLocationName}}{{'_Lobby_Central_Assist_Eligible_User_Select_Text_' | translate}}" 
  actionYesLabel="{{'_General_Assist_Text_' | translate}}"
  actionNoLabel="{{'_General_Button_Close_Text_' | translate }}"
  [(lobbyEntry)]="assistingLobbyEntry"
   >
</app-impersonate-assist>
